module.exports = __webpack_public_path__ + "media/images/captive_portal/plus-77f80752b171e242a40f48c54a1eb583.png";